import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NotesHoverService } from '../../services/notes-hover.service';

@Component({
  selector: 'ngx-notes-cell',
  // templateUrl: './notes-cell.component.html',
  
  //(mouseover)="onHover()"
  //(mouseout)="onOut()"
  template: `
    <div class='cell'
    (click)="onHover()"
    >
        {{this.shortened}}
    </div>`,
  styleUrls: ['./notes-cell.component.scss']
})
export class NotesCellComponent implements ViewCell, OnInit {
  constructor (
    private notesHoverService : NotesHoverService,
  ){}

  public shortened : string;
  public full : string;
  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    this.full = this.value;
    this.shortened = this.value.length > 20 ? this.value.substring(0,17) + "..." : this.value;
  }

  onHover() {
    if(this.shortened.length > 20) {
      localStorage.setItem('hoveredNote', this.full);
      this.notesHoverService.noteHover$.next();
    }
  }
  onOut() {
    localStorage.setItem('hoveredNote', "");
    this.notesHoverService.noteOut$.next();
  }
}